import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import footprintImage from '../../../../assets/images/technology/footprint/main.jpg';
import './Footprint.css';

const paragraphs = [
  'We take a proactive stance on digital security. By combining advanced encryption standards with layered access protocols, we ensure that every interaction within our ecosystem is protected.',
  'Our systems are regularly monitored and updated to adapt to the evolving security landscape, providing you with peace of mind as you navigate the international financial markets.',
];

const Footprint = () => {
  return (
    <section className="technology-footprint">
      <div className="technology-footprint__inner">
        <Reveal className="technology-footprint__copy">
          <h2 className="technology-footprint__title">
            Securing Your Digital Footprint.
          </h2>
          {paragraphs.map((paragraph) => (
            <p key={paragraph} className="technology-footprint__text">
              {paragraph}
            </p>
          ))}
        </Reveal>

        <Reveal className="technology-footprint__media" delay={80}>
          <img
            className="technology-footprint__image"
            src={footprintImage}
            alt=""
            aria-hidden="true"
          />
        </Reveal>
      </div>
    </section>
  );
};

export default Footprint;
